import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GroupsState } from './groups.reducer';

export const selectGroupsState = createFeatureSelector<GroupsState>('groups');

export const selectGroups = createSelector(selectGroupsState, (state) => state.groups);
export const selectGroupsMeta = createSelector(selectGroupsState, (state) => state.meta);
export const selectGroupsLoading = createSelector(selectGroupsState, (state) => state.isLoading);
export const selectGroupsSubmitting = createSelector(selectGroupsState, (state) => state.isSubmitting);
export const selectGroupsDeleting = createSelector(selectGroupsState, (state) => state.isDeleting);
export const selectGroupsBulkDeleting = createSelector(selectGroupsState, (state) => state.isBulkDeleting);
export const selectGroupsError = createSelector(selectGroupsState, (state) => state.error);
export const selectGroupsLastQuery = createSelector(selectGroupsState, (state) => state.lastQuery);
